






































































import { Component, Vue } from 'vue-property-decorator';
import { validationMixin } from 'vuelidate';
import vSelect from 'vue-select';
import { required } from 'vuelidate/lib/validators';
import secondaryNav from '@/components/navbars/secondary-nav.vue';

import { ThingGroup, ThingGroupsApi, Transceiver } from '../../../api';

@Component({
	components: {
		secondaryNav,
		vSelect,
	},
	validations: {
		form: {
			name: { required },
			firmwareVersion: { required },
		},
	},
	mixins: [validationMixin],
})
export default class SensorUpdate extends Vue {
	public form = {
		name: '',
		firmwareVersion: '',
	};

	public group: ThingGroup | null = null;
	public $bvToast: any;
	public loading = true;
	public submitStatus: 'ERROR' | 'PENDING' | 'OK' | null = null;
	public type: null;

	private api: ThingGroupsApi;

	constructor() {
		super();
		this.api = new ThingGroupsApi();
	}

	public async onSubmit(e: Event) {
		e.preventDefault();
		this.$v.$touch();
		if (this.$v.$invalid) {
			this.submitStatus = 'ERROR';
			return;
		}
		this.submitStatus = 'PENDING';

		const { thingGroupName } = this.$route.params;
		const group: ThingGroup = this.form;
		const response = await new ThingGroupsApi().updateThingGroup(thingGroupName, { data: group });

		this.$bvToast.toast('Successfully updated group', {
			title: 'Successfully updated group',
			variant: 'success',
			solid: true,
			noAutoHide: true,
			toaster: 'b-toaster-top-right',
		});

		setTimeout(() => {
			this.submitStatus = 'OK';
			this.$router.push({ name: 'thing-groups.list' });
		}, 1000);
	}

	public async load() {
		const { thingGroupName } = this.$route.params;

		this.loading = true;
		try {
			const response = await this.api.getThingGroup(thingGroupName, { params: {} });
			console.log(response);
			const group: ThingGroup = response.data;
			this.form.name = group.name;
			this.form.firmwareVersion = group.firmwareVersion;

			this.group = group;
		} catch (e) {
			this.group = null;
		} finally {
			this.loading = false;
		}
	}

	public created() {
		this.load();
	}
}
